import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payroll-masters',
  templateUrl: './payroll-masters.component.html',
  styleUrls: ['./payroll-masters.component.css']
})
export class PayrollMastersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/payroll/payroll-masters/payroll-masters.component.ts